// src/pages/ChatPage.js

import React, { useEffect, useState } from 'react';
import Layout from '../Common/Components/Layout/Layout';

// 1. Import BOTH your original and your new UAE MT component
import UaeMtChatBotComponent from "../Pages/UaeMt/UaeMtChatBotComponent";
import ChatBotComponent from "./ChatBotComponent/ChatBotComponent";

const MIDDLE_EAST_MT_SOURCES = ["uae_mt", "ksa_mt"];

const ChatPage = ({ setIsExpandedHeader }: { setIsExpandedHeader?: (v: boolean) => void }) => {

  // This state reads from localStorage ONLY on the first load.
  const [dataSource, setDataSource] = useState(() => {
    return localStorage.getItem("DataSource") || "topline";
  });

  // This state handles the "double-click" fix.
  const [initialAction, setInitialAction] = useState<string | null>(null);

  // Notify the Layout HOC whether this market needs a taller header.
  useEffect(() => {
    setIsExpandedHeader?.(MIDDLE_EAST_MT_SOURCES.includes(dataSource));
  }, [dataSource, setIsExpandedHeader]);

    // This function is how children will change the view.
    const handleDataSourceChange = (sourceName: string, action: string | null = null) => {
        localStorage.setItem('DataSource', sourceName);
        setDataSource(sourceName);
        setInitialAction(action);
    };

    // This hook cleans up the action after it's been sent to the child.
    useEffect(() => {
        if (initialAction) {
            setInitialAction(null);
        }
    }, [initialAction]);

  if (MIDDLE_EAST_MT_SOURCES.includes(dataSource)) {
    return (
      <UaeMtChatBotComponent
        onReset={() => handleDataSourceChange("topline")}
        initialAction={initialAction}
        setHeaderActions={() => {}}
        setCenterTitle={() => {}}
      />
    );
  }
  return <ChatBotComponent onSourceSelect={handleDataSourceChange} />;
};
// 3. Wrap the dispatcher component with the Layout HOC
export default Layout(ChatPage);